import type { CatalogTree } from '../types';

export const reports = {
  tabs: {
    label: 'Rapor türleri',
    conversations_by_channel_day: 'Kanala göre konuşmalar',
    ai_vs_staff: 'Asistan ve personel',
    first_reply_time: 'İlk yanıt süresi',
    handoff_reasons: 'Aktarma nedenleri',
    most_asked_products: 'En çok sorulan ürünler',
    top_question_types: 'Soru türleri',
    unanswered_questions: 'Cevaplanamayan sorular',
  },
  chart: '{name} grafiği',
  periodTooLong: 'Dönem en fazla 366 gün olabilir.',
  empty: 'Bu dönemde veri yok.',
  notFound: 'Böyle bir rapor yok.',
  backToReports: 'Raporlara dön',
  columns: {
    day: 'Gün',
    channel: 'Kanal',
    conversations: 'Konuşma',
    messagesIn: 'Gelen mesaj',
    median: 'Medyan',
    p90: '90. yüzdelik',
    samples: 'Örnek',
    reason: 'Neden',
    handoffs: 'Aktarma',
    share: 'Pay',
    product: 'Ürün',
    asks: 'Soru',
    intent: 'Soru türü',
    count: 'Sayı',
    question: 'Soru',
    topic: 'Konu',
    lastAsked: 'Son sorulma',
  },
  series: {
    ai: 'Asistan',
    staff: 'Personel',
  },
  stats: {
    aiHandled: 'Asistanın yanıtladığı',
    staffHandled: 'Personelin yanıtladığı',
    aiShare: 'Asistan payı',
    periodMedian: 'Dönem medyanı',
  },
  answerInGaps: "Asistan → Boşluklar'da cevapla",
} as const satisfies CatalogTree;
